import React from 'react';
import PageAuthorize from '../../../security/PageAuthorize';
//import ApiDocumentation from './ApiDocumentation';
import RouteTitle from '../../../presentation/RouteTitle';
import Loadable from 'react-loadable';

const LoadableApiDocumentation = Loadable( {
  loader: () => import( /* webpackChunkName: "ApiDocChunk" */ './ApiDocumentation' ),
  loading: () => <div> LOADING </div>,
} );

class ApiDocumentationList extends React.Component {
  render(){
    return (
      <PageAuthorize groups={['Administrators','Operations','Management','Entity','Wholesale']}>
        <RouteTitle title='API Documentation' />
        <LoadableApiDocumentation />
      </PageAuthorize>
    );
  }

}

export default ApiDocumentationList;



// WEBPACK FOOTER //
// ./src/content/documentation/components/ApiDocumentationList.js